import Breakpoints from '../breakpoints.js'

/** @param {Array<T>} values - Array of correct values validator can receive */
export const createBreakpointValidator = (values) => (value) => {
  const res = values.includes(value)
    || (
      Object.keys(value).every(k => Object.keys(Breakpoints).includes(k) || k === 'default')
      && Object.values(value).every(v => values.includes(v))
    )
  if (!res) {
    console.warn('invalid prop value === ', value)
  }
  return res
}
